module.exports = __webpack_public_path__ + "img/honorary3.f7862c78.jpg";